import { render, staticRenderFns } from "./FAQWalkVersionCheck.vue?vue&type=template&id=1ecab526&scoped=true"
import script from "./FAQWalkVersionCheck.vue?vue&type=script&lang=js"
export * from "./FAQWalkVersionCheck.vue?vue&type=script&lang=js"
import style0 from "./FAQWalkVersionCheck.vue?vue&type=style&index=0&id=1ecab526&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecab526",
  null
  
)

export default component.exports